import React, { FunctionComponent, FormEvent, useState, useEffect } from 'react';
import { Button, Collapse, Form, Space } from 'antd';
import { CollapseWrapper } from 'common/components/styled';
import { SubmitButton, Input } from 'common/components';
import { openModal } from 'common/helpers/modal';
import { regenerateUpstreamclientsecretcodeRequest } from 'features/organisation/actions/organisationActions';
import { useDispatch } from 'react-redux';

import styled from 'styled-components';

import { hexToRGBA } from 'common/helpers/utils';
import { colors } from 'theme/variables';

import * as S from 'features/upload/components/BenefitChangeSuggestionsFormItem/shared/styles';

export const SuggestionWrapper = styled.div<{ color?: string }>(
    ({ color }) => `
    position: relative;
    border: 1px solid ${color || colors.borderGray};
    background-color: ${color ? hexToRGBA(color, 0.1) : 'transparent'};
    border-radius: 4px;
    padding: 1.5rem;
    margin-bottom: 1rem;
`,
);

export const ChangeInfo = styled.div`
    position: absolute;
    top: -0.5rem;
    left: -0.5rem;
`;

export const SuggestionValue = styled.h3<{ topMargin?: string }>(
    ({ topMargin }) => `
    margin: ${topMargin || 0} 0 0;
`,
);

export const InputsWrapper = styled(Space)`
    width: 100%;

    > .ant-space-item:first-child {
        flex: 1;
    }
`;

export const RemoveButton = styled(Button)`
    position: absolute;
    right: -0.5rem;
    top: -0.5rem;
`;

type Props = {
    secret: string;
    id: number;
    organisationId: number;
};

export const UpstreamClientSecretCode: FunctionComponent<Props> = ({
    secret,
    id,
    organisationId,
}) => {
    const dispatch = useDispatch();
    const showRegenerateSecretModel = (e: FormEvent) => {
        e.preventDefault();
        return openModal({
            okText: 'Reset Client Secret Key',
            cancelText: 'Cancel',
            callback: () => {
                dispatch(
                    regenerateUpstreamclientsecretcodeRequest({
                        id,
                        organisationId,
                    }),
                );
            },
            title: 'Warning: This action will reset client secret key, do you want to proceed?',
        });
    };
    return (
        <CollapseWrapper>
            <Collapse>
                <Collapse.Panel header="Client secret" key="clientSecret">
                    <S.SuggestionWrapper>
                        <Form.Item>
                            <Input
                                name="secretCode"
                                value={secret}
                                placeholder={secret}
                                label="Upstream Client Secret"
                                readOnly={true}
                                required={false}
                            />
                        </Form.Item>
                        <SubmitButton
                            value={'Regenerate Client Secret'}
                            onClick={(e: FormEvent) => {
                                showRegenerateSecretModel(e);
                            }}
                        />
                    </S.SuggestionWrapper>
                </Collapse.Panel>
            </Collapse>
        </CollapseWrapper>
    );
};
